import { Typography, Combobox, ButtonProps } from "@altimateai/lego";

interface TeamContextSectionProps {
  teamId: string | null;
  teamOptions: Array<{ label: string; value: string }>;
  teamsLoading: boolean;
  onChange: (teamId: string | null) => void;
}

export const TeamContextSection: React.FC<TeamContextSectionProps> = ({
  teamId,
  teamOptions,
  teamsLoading,
  onChange,
}) => {
  return (
    <div className="al-h-full">
      <Typography
        variant="body"
        size="xs"
        weight="medium"
        className="al-text-indigo-700 al-uppercase al-mb-1 al-block"
      >
        Team Context (Optional)
      </Typography>
      <div className="al-bg-indigo-50 al-border al-border-indigo-200 al-p-3 al-rounded-lg al-min-h-[120px]">
        <Typography size="xs" className="al-text-gray-600 al-mb-2 al-block">
          Select a team to run evaluations with that team&apos;s permissions. If
          not selected, uses the team from dashboard level selection.
        </Typography>
        <Combobox
          id="test-case-team-selector"
          value={teamId || ""}
          options={teamOptions}
          onChange={(value: string) => onChange(value === "" ? null : value)}
          placeholder={teamsLoading ? "Loading teams..." : "Select Team"}
          buttonProps={
            {
              variant: "outline",
              className:
                "al-w-full al-border-indigo-300 al-bg-indigo-50 hover:al-border-indigo-400 focus:al-border-indigo-400 focus:al-ring-2 focus:al-ring-indigo-100",
            } as ButtonProps
          }
          popoverContentProps={{
            className: "al-bg-indigo-50 al-border-indigo-300",
          }}
        />
      </div>
    </div>
  );
};
